import axios from 'axios';
import _ from 'lodash';
import { apiErrorHandler } from 'helpers/ApiHelper';

export const FETCH_BLACKOUT_DEFINITION = 'FETCH_BLACKOUT_DEFINITION';
export const RESET_BLACKOUT_DEFINITION = 'RESET_BLACKOUT_DEFINITION';

export async function fetchBlackoutDefinition() {
  const blackout = _.get(window.ExternalConfig, 'blackout', {});
  const { definitions } = blackout;
  const request = axios.get(definitions).catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_BLACKOUT_DEFINITION,
    payload: request,
  };
}
